import React from "react";
import SEO from "../components/SEO";
import HeroSection from "../components/HeroSection";
import WhyChooseUs from "../components/WhyChooseUs";
import KeyFeatures from "../components/KeyFeatures";
import CallToAction from "../components/CallToAction";
import ContactSection from "../components/ContactSection";

const Home = () => {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "RiskDiscover",
      "description": "AI-powered risk assessment platform for insurance professionals",
      "url": "https://app.riskdiscover.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://app.riskdiscover.com/search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      },
      "provider": {
        "@type": "Organization",
        "name": "moredevs.ai",
        "url": "https://moredevs.ai"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "AI-Powered Risk Assessment",
      "description": "Comprehensive business risk evaluation using artificial intelligence and machine learning algorithms",
      "provider": {
        "@type": "Organization",
        "name": "moredevs.ai",
        "url": "https://moredevs.ai"
      },
      "serviceType": "Risk Assessment Software",
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "Insurance Professionals"
      },
      "areaServed": "Europe",
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "EUR"
      },
      "hasOfferingCatalog": {
        "@type": "OfferingCatalog",
        "name": "Risk Assessment Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Company Risk Analysis",
              "description": "Detailed analysis of company profiles including industry classification, financial health, and location-based risk factors"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service", 
              "name": "Dynamic Risk Scoring",
              "description": "Real-time risk score calculation based on multiple data points and industry benchmarks"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "PDF Report Generation",
              "description": "Professional risk assessment reports with comprehensive analysis and recommendations"
            }
          }
        ]
      },
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web-based",
      "processingTime": "PT2M",
      "serviceOutput": "Risk Assessment Report"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <SEO 
        title="Transform Your Risk Assessment with AI-Powered Insights"
        description="Transform your business risk assessment with AI-powered insights. Fast, accurate risk evaluations for insurance professionals. Try RiskDiscover today."
        canonical="/"
        type="website"
        structuredData={structuredData}
      />
      <HeroSection />
      <WhyChooseUs />
      <KeyFeatures />
      <CallToAction />
      <ContactSection />
    </div>
  );
};

export default Home;
